import { Token, type Lexer } from '@parser';

const arrowSymbolLeft = '[←⇐⇽⇠]';
const arrowSymbolRight = '[→⇒⇾⇢⤑]';
const arrowSymbolBoth = '[↔⇔⇿]';
const arrowSingle = `(?:${arrowSymbolLeft}|${arrowSymbolRight}|${arrowSymbolBoth})`;

const arrowShaftAscii = '[-=.~]';
const arrowShaftSymbol = '[⋯]';
const arrowShaft = `(?:${arrowShaftAscii}|${arrowShaftSymbol})`;

const arrowHeadAscii = '[xo#<|>\\{\\}\\(\\)]';
const arrowHeadSymbol = '[◇◆□■○●△▲▽▼◁◀▷▶]';
const arrowHead = `(?:${arrowHeadAscii}|${arrowHeadSymbol})`;
// Allow arrows with heads and a single shaft char, but require ≥2 shaft chars when no heads
const arrowMultiWithHead = `(?:${arrowHead}+${arrowShaft}+${arrowHead}*|${arrowHead}*${arrowShaft}+${arrowHead}+)`;
const arrowMultiNoHead = `(?:${arrowShaft}{2,})`;
const arrowMulti = `(?:${arrowMultiWithHead}|${arrowMultiNoHead})`;

// Lexer-use regex: matches at current position. Note: the leading ^ applies when matching from the start.
const arrow = `^${arrowSingle}|${arrowMulti}`;
const arrowRegex = new RegExp(arrow, 'g');

// Validator-use regex: must match the entire string to be considered an arrow name.
const arrowWhole = `^(?:${arrowSingle}|${arrowMulti})$`;
const arrowWholeRegex = new RegExp(arrowWhole);

// Public helper to validate arrow class/display names without duplicating patterns
export function isArrowName(text: string): boolean {
  return arrowWholeRegex.test(text);
}

export class Arrow extends Token<string> {
  static lex(lexer: Lexer): Arrow | undefined {
    const match = lexer.consumeMatch(arrowRegex);
    if (match === undefined) {
      return undefined;
    }
    return new Arrow(match.text, {
      start: match.start,
      end: match.end,
      value: match.text
    });
  }
}
